import React from "react";
import { useNavigate } from "react-router-dom";
import "./AboutLegends.css";

const CATEGORIES = [
  {
    id: "ancient-gods",
    label: "Ancient\nCharacters",
    image:
      "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/Group+163860.png",
    link: "/student/start-your-quest",
  },
  {
    id: "indian-history",
    label: "Indian\nHistory",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/leg2.png",
    link: "/student/start-your-quest",
  },
  {
    id: "indian-festival",
    label: "Indian\nFestival",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/leg3.png",
    link: "/student/festival",
  },
  {
    id: "indian-places",
    label: "Indian\n Monuments",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/leg4.png",
    comingSoon: true,
  },
  {
    id: "indian-shlokas",
    label: "Indian\n Shlokas",
    image: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/leg5.png",
    comingSoon: true,
  },
];

export const AboutLegends = () => {
  return (
    <section className="aboutLegends" id="about-legends">
      <div className="aboutLegends__container">
        <div className="mob-dblock">
          <span className="aboutLegends__badge mb-3">About Yuva Quest</span>
          <h2 className="aboutLegends__title mb-0">
            <img
              className="howitwrkicn"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
              alt=""
            />
            Meet Your New Favorite Legends
            <img
              className="howitwrkrgticn"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
              alt=""
            />
          </h2>
        </div>
        <div className="aboutLegends__left">
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev2/Meet-Favorite-Legent.deb027772f5c6e2e37a9.png"
            alt="Father and son exploring Yuva Quest"
            className="aboutLegends__heroImage"
          />
        </div>

        <div className="">
          <div className="mob-dnone">
            <span className="aboutLegends__badge mb-3">About Yuva Quest</span>
            <h2 className="aboutLegends__title mb-3">
              <img
                className="howitwrkicn"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
                alt=""
              />
              Meet Your New Favorite Legends
              <img
                className="howitwrkrgticn"
                src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
                alt=""
              />
            </h2>
          </div>

          <div>
            <p className="aboutLegends__description">
              Yuva Quest is your treasure map to the most legendary characters,
              daring freedom fighters, and mind-blowing heritage of India.
              Forget boring history. We bring you Indian Culture like you&#39;ve
              never experienced before. Your adventure is waiting. Let's go!
            </p>
          </div>
        </div>
      </div>

      <div className="Legend-CategoryContaner mt-4">
        {/* Category cards */}
        <div className="aboutLegends__categories">
          {CATEGORIES.map((cat) => (
            <CategoryCard key={cat.id} {...cat} />
          ))}
        </div>
      </div>
    </section>
  );
};

/** Single category card with overlaid label */
const CategoryCard = ({ id, label, image, comingSoon, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link && !comingSoon) {
      navigate(link);
    }
  };

  return (
    <div
      className={`aboutLegends__card ${comingSoon ? "aboutLegends__card--disabled" : ""}`}
      id={`category-${id}`}
      onClick={handleClick}
    >
      <img
        src={image}
        alt={label.replace("\n", " ")}
        className="aboutLegends__cardImage"
      />
      <span className="aboutLegends__cardLabel">
        {label.split("\n").map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < label.split("\n").length - 1 && <br />}
          </React.Fragment>
        ))}
      </span>
      {comingSoon && (
        <span className="aboutLegends__comingSoon">COMING SOON!</span>
      )}
    </div>
  );
};
